import { render, staticRenderFns } from "./AccessRequestModal.vue?vue&type=template&id=12560527&scoped=true&"
import script from "./AccessRequestModal.vue?vue&type=script&lang=js&"
export * from "./AccessRequestModal.vue?vue&type=script&lang=js&"
import style0 from "./AccessRequestModal.vue?vue&type=style&index=0&id=12560527&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12560527",
  null
  
)

export default component.exports